import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import Form from '../../components/Form';
import Input from '../../components/Input';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import Label from '../../components/Label';

const messages = defineMessages({
  emailAddress: {
    id: 'forgot-password.emailAddressPlaceholder',
    defaultMessage: 'E-Mail Address',
  },
});

class EnterEmail extends React.PureComponent {
  static defaultState = {
    errorLabel: null,
  };

  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = EnterEmail.defaultState;
  }

  _onChange = (e, { value, name } = {}) => {
    value = value || e.target.value;
    name = name || e.target.name;
    this.setState({ [name]: value });
  };

  _onSubmit = (e) => {
    const { username } = this.state;
    e.preventDefault();
    if (!username) {
      this.setState({
        errorLabel: (
          <Label role="tooltip" basic color="red" pointing>
            <FormattedMessage id="forgot-password.missingEmail" defaultMessage="Please enter an e-mail address" />
          </Label>
        ),
      });
    } else {
      this.props.onSubmit(username);
    }
  };

  render() {
    const { intl } = this.props;
    const { errorLabel, username } = this.state;
    return (
      <Form onSubmit={this._onSubmit}>
        <Form.Field>
          <label htmlFor="forgotten-email-input">
            <FormattedMessage {...messages.emailAddress} />
          </label>
          <Input type="email" name="username" value={username} icon iconPosition="left" onChange={this._onChange}>
            <Icon name="mail" />
            <input
              id="forgotten-email-input"
              aria-label={intl.formatMessage(messages.emailAddress)}
              autoCapitalize="off"
              autoComplete="off"
              required
              aria-required
            />
          </Input>
          { errorLabel }
        </Form.Field>
        <Button primary type="submit" fluid data-cy="forgot-password-reset-password-button">
          <FormattedMessage id="forgot-password.resetPasswordButton" defaultMessage="Reset Password" />
        </Button>
      </Form>
    );
  }
}

export default injectIntl(EnterEmail);
